import {
	INITIAL_PRODUCT_REQUEST,
	FINAL_PRODUCT_REQUEST,
	FETCH_PRODUCT_SUCCESS,
	FETCH_PRODUCT_ERROR,
	DELETE_PRODUCT_SUCCESS,
	SAVE_PRODUCT_SUCCESS,
	UPDATE_PRODUCT_PRICES_LOCALLY,
} from "../../types/product.types";

const initialState = {
	products: [],
	crops: [],
	pests: [],
	aptitudes: [],
	categories: [],
	dealers: [],
	chemicals: [],
	active_ingredients: [],
	countries: [],
	customers: [],
	estates: [],
	base_permissions: [],
	quantity: 0,
	last_page: 0,
	from: 0,
	to: 0,
	isFetching: false,
	error: null,
};

function products(state = initialState, action) {
	switch (action.type) {
		case INITIAL_PRODUCT_REQUEST:
			return {
				...state,
				isFetching: true,
				error: null,
			};
		case FINAL_PRODUCT_REQUEST:
			return {
				...state,
				isFetching: false,
			};
		case FETCH_PRODUCT_SUCCESS:
			return {
				...state,
				isFetching: false,
				products: action.payload.products,
				crops: action.payload.crops,
				pests: action.payload.pests,
				aptitudes: action.payload.aptitudes,
				categories: action.payload.categories,
				dealers: action.payload.dealers,
				chemicals: action.payload.chemicals,
				active_ingredients: action.payload.active_ingredients,
				customers: action.payload.customers,
				estates: action.payload.estates,
				countries: action.payload.countries,
				quantity: action.payload.quantity,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
			};
		case FETCH_PRODUCT_ERROR:
			return {
				...state,
				isFetching: false,
				error: action.payload.error,
				products: [],
				crops: [],
				pests: [],
				aptitudes: [],
				categories: [],
				dealers: [],
				chemicals: [],
				active_ingredients: [],
				customers: [],
				estates: [],
				countries: [],
				quantity: 0,
				last_page: 0,
				from: 0,
				to: 0,
			};
		case DELETE_PRODUCT_SUCCESS:
			return {
				...state,
				isFetching: false,
				products: action.payload.products,
				crops: action.payload.crops,
				pests: action.payload.pests,
				aptitudes: action.payload.aptitudes,
				categories: action.payload.categories,
				dealers: action.payload.dealers,
				chemicals: action.payload.chemicals,
				active_ingredients: action.payload.active_ingredients,
				customers: action.payload.customers,
				estates: action.payload.estates,
				countries: action.payload.countries,
				quantity: action.payload.quantity,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
			};
		case SAVE_PRODUCT_SUCCESS:
			return {
				...state,
				isFetching: false,
				products: action.payload.products,
				crops: action.payload.crops,
				pests: action.payload.pests,
				aptitudes: action.payload.aptitudes,
				categories: action.payload.categories,
				dealers: action.payload.dealers,
				chemicals: action.payload.chemicals,
				active_ingredients: action.payload.active_ingredients,
				customers: action.payload.customers,
				estates: action.payload.estates,
				countries: action.payload.countries,
				quantity: action.payload.quantity,
				last_page: action.payload.last_page,
				from: action.payload.from,
				to: action.payload.to,
			};
		case UPDATE_PRODUCT_PRICES_LOCALLY:
			return {
				...state,
				products: action.payload.products,
			};
		default:
			return state;
	}
}

export default products;
